import axios from 'axios';
import { PRODUCT_TYPES } from '../utils/constants';
import { handleError } from '../utils/error';
import { getProduct } from './Products';
const BASE_URL = process.env.MOALPRESS_URL;
const WP_USER = process.env.MOALPRESS_WP_USER;
const WP_APP_PASSWORD = process.env.MOALPRESS_WP_APP_PASSWORD;
// Keys that WordPress expects as comma-separated lists, not repeated params.
const COMMA_JOIN_KEYS = new Set([
    '_fields',
    'include',
    'exclude',
    'slug',
    'product_item_number',
    'products_slug',
    'access_levels_slug',
    'authors_slug',
    'portfolios_slug',
    'categories_slug',
    'tags_slug',
    'portfolio_id'
]);
function buildQuery(params) {
    if (!params)
        return '';
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined)
            return;
        const push = (v) => {
            const val = v instanceof Date ? v.toISOString() : String(v);
            search.append(key, val);
        };
        if (Array.isArray(value)) {
            // If WP expects a comma-separated list for this key, join instead of repeating.
            if (COMMA_JOIN_KEYS.has(key)) {
                const joined = value
                    .filter((v) => v !== null && v !== undefined)
                    .map((v) => (v instanceof Date ? v.toISOString() : String(v)))
                    .join(',');
                if (joined)
                    search.set(key, joined);
            }
            else {
                value.forEach((v) => {
                    if (v === null || v === undefined)
                        return;
                    push(v);
                });
            }
        }
        else {
            push(value);
        }
    });
    const qs = search.toString();
    return qs ? `?${qs}` : '';
}
// Generic request helper: returns only data, keeps consistent error handling
async function wpGet(path, params) {
    if (params === null || params === void 0 ? void 0 : params.all) {
        return wpGetAll(path, params);
    }
    const query = buildQuery(params);
    const url = `${BASE_URL}${path}${query}`;
    try {
        const { data } = await axios.get(url, {
            headers: {
                Authorization: `Basic ${Buffer.from(`${WP_USER}:${WP_APP_PASSWORD}`).toString('base64')}`
            }
        });
        return data;
    }
    catch (e) {
        const err = e;
        handleError(`GET ${path}`, err);
        throw err;
    }
}
async function wpGetAll(path, params) {
    const allData = [];
    let page = 1;
    let totalPages = 1;
    // Remove 'all' from params to avoid infinite recursion or passing it to WP
    const { all, ...restParams } = params || {};
    try {
        do {
            const query = buildQuery({ ...restParams, per_page: 100, page });
            const url = `${BASE_URL}${path}${query}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Basic ${Buffer.from(`${WP_USER}:${WP_APP_PASSWORD}`).toString('base64')}`
                }
            });
            if (Array.isArray(response.data)) {
                allData.push(...response.data);
            }
            totalPages = parseInt(response.headers['x-wp-totalpages'] || '1', 10);
            page++;
        } while (page <= totalPages);
    }
    catch (e) {
        const err = e;
        handleError(`GET ALL ${path}`, err);
        throw err;
    }
    return allData;
}
export const getWPCategories = async (params) => {
    return wpGet('/wp-json/wp/v2/categories', params);
};
export const getWPTags = async (params) => {
    return wpGet('/wp-json/wp/v2/tags', params);
};
export const getWPProducts = async (params) => {
    return wpGet('/wp-json/wp/v2/products', params);
};
export const getWPProductsWithCategories = async (params) => {
    return wpGet('/wp-json/mp/v1/categories-with-content', params);
};
export const getWPAccessLevels = async (params) => {
    return wpGet('/wp-json/wp/v2/access_levels', params);
};
export const getWPAuthors = async (params) => {
    return wpGet('/wp-json/wp/v2/authors', params);
};
export const getWPPortfolios = async (params) => {
    return wpGet('/wp-json/wp/v2/portfolios', params);
};
export async function getPages(params) {
    return wpGet('/wp-json/wp/v2/pages', params);
}
export async function getMOALContent(params) {
    return wpGet('/wp-json/wp/v2/moal_content', params);
}
export const advancedSearch = async (params) => {
    return wpGet('/wp-json/mp/v1/advanced-search', params);
};
export const getWPUserRolesByEmail = async (email) => {
    return wpGet('/wp-json/mp/v1/user-roles', { email });
};
export const getWPNavBySlug = async (slug) => {
    return wpGet('/wp-json/mp/v1/navigation', { slug });
};
export const getContactFormConfig = async () => {
    return wpGet('/wp-json/moal-contact-form/v1/config');
};
export const bustFlagshipCache = async ({ tag }) => {
    var _a;
    if (!BASE_URL) {
        return null;
    }
    try {
        const { data: flagship, status } = await getProduct({
            itemNumber: PRODUCT_TYPES.FLAGSHIP
        });
        if (status !== 200 || !((_a = flagship === null || flagship === void 0 ? void 0 : flagship.urls) === null || _a === void 0 ? void 0 : _a.website)) {
            return;
        }
        const siteURL = new URL('/api/revalidate', flagship.urls.website);
        siteURL.searchParams.set('tag', tag);
        return await axios.post(siteURL.toString());
    }
    catch (error) {
        handleError('bustFlagshipCache', error);
        return null;
    }
};
//# sourceMappingURL=MOALPress.js.map